import React,{useState,useEffect} from 'react';
import './App.css';
import Post from './Post'
import {db,auth} from './firebase';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import {Button, Input} from '@material-ui/core'
import ImageUpload from "./Imageupload"


function getModalStyle() {
  const top = 50 ;
  const left =50 ;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));
function App() {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [posts,setPosts] = useState([]);
  const [open,setOpen]= useState(false);
  const [username,setUsername]= useState('');
  const [password,setPassword]= useState('');
  const [email,setEmail]= useState(''); 
  const [user,setUser] = useState(null);
  const [openSignIn, setOpenSignIn]=useState(false);




useEffect(()=>{
  db.collection('posts').orderBy('timestamp','desc').onSnapshot(snapshot=>{
    setPosts(snapshot.docs.map(doc=>({
      id: doc.id,
      post: doc.data(),
    })));
  })
  },[]);

const signUp = (event) => {
  event.preventDefault();
  auth.createUserWithEmailAndPassword(email,password)
  .then((authUser)=>{
   return authUser.user.updateProfile({
      displayName:username,
    })
  })
  .catch((error)=> alert(error.message));

  setOpen(false);
  }
  useEffect(()=>{
    const unsubscribe = auth.onAuthStateChanged((authUser)=>{
        if(authUser){
          console.log(authUser)
          setUser(authUser);
        
          }else{
          setUser(null);
        }
        
      })
      return () => {
        unsubscribe();
      }
},[user,username]);

const signIn = (event)=>{
  event.preventDefault();
  auth.signInWithEmailAndPassword(email,password)
  .catch((error)=> alert(error.message));

  setOpenSignIn(false);
}
  return (
    <div className="app">



      <Modal
      open = {open}
      onClose = {()=>setOpen(false)}
          >
            <div style={modalStyle} className={classes.paper}>
     <form className="app_signup">
              <center>
                  <img 
            className="app_headerImage"
            src="https://www.instagram.com/static/images/web/mobile_nav_type_logo.png/735145cfe0a4.png"
            alt =""

            />
            </center>
            <Input
            placeholder = "Username"
            type = "text"
            value = {username}
            onChange={(e) => setUsername(e.target.value)}

            />
            <Input
            placeholder = "email"
            type = "email"
            value = {email}
            onChange={(e) => setEmail(e.target.value)}

            />
                  <Input
            placeholder = "password"
            type = "password"
            value = {password}
            onChange={(e) => setPassword(e.target.value)}

            />
              <Button type ="submit" onClick={signUp}>Sign up</Button>
         </form>
        </div>

      </Modal>

      <Modal
      open = {openSignIn}
      onClose = {()=>setOpenSignIn(false)}
          >
            <div style={modalStyle} className={classes.paper}>
     <form className="app_signup">
              <center>
                  <img 
            className="app_headerImage"
            src="https://www.instagram.com/static/images/web/mobile_nav_type_logo.png/735145cfe0a4.png"
            alt =""

            />
            </center>
           
            <Input
            placeholder = "email"
            type = "email"
            value = {email}
            onChange={(e) => setEmail(e.target.value)}

            />
                  <Input
            placeholder = "password"
            type = "password"
            value = {password}
            onChange={(e) => setPassword(e.target.value)}

            />
              <Button type ="submit" onClick={signIn}>Login in</Button>
         </form>
        </div>

      </Modal>
    <div className="app_header">
      
      <img 
      className="app_headerImage"
      src="https://www.instagram.com/static/images/web/mobile_nav_type_logo.png/735145cfe0a4.png"
      alt =""

      />
       {
        user ? (
          <Button onClick={()=> auth.signOut()}>Logout</Button>
        ):(
          <div className="login_container">
            
          <Button onClick={()=> setOpenSignIn(true)}>SignIn</Button>
          <Button onClick={()=> setOpen(true)}>Sign Up</Button>
          </div>
        )
      }
      </div>
     
      <div className="app_post">    
        {
        posts.map(({id,post})=>(
          <Post 
          key = {id} postId={id} user={user}
          username = {post.username}
          caption = {post.caption}
          imageUrl = {post.imageUrl}
          />
        ))
      }
      </div>
      {user?.displayName ? (
                  <ImageUpload username={user.displayName}/>
      ):(
<h5></h5>
      )
}
    
    </div>
  );
}

export default App;
